import moment from "moment";
import React from "react";
import round from "lodash/round";
import { getBodywweightAndUnit } from "../../../../../utils/converters/convert-units";
import { useRillContext } from "../../../../../rill/RillReact/share/base";

const StatInformation = ({ stat, column, hideExtras }) => {
  const { locals } = useRillContext();

  const {
    activeUser: { units },
  } = locals;
  return (
    <div className={column ? "information-column" : "information"}>
      {!hideExtras && column && (
        <div className="date">
          {moment(stat.utcDate, "YYYYMMDD").format("LL")}
        </div>
      )}
      <div className="protein">
        {stat.nutrients?.proteins
          ? `${round(stat.nutrients.proteins)}g `
          : "- "}
        <span className="mobile-hidden">Protein</span>
      </div>
      <div className="carbs">
        {stat.nutrients?.carbs ? `${round(stat.nutrients.carbs)}g ` : "- "}
        <span className="mobile-hidden">Carbs</span>
      </div>
      <div className="fat">
        {stat.nutrients?.fats ? `${round(stat.nutrients.fats)}g ` : "- "}
        <span className="mobile-hidden">Fat</span>
      </div>
      {!hideExtras && stat.bodyWeight && (
        <div className="bodyweight">
          <span className="only-show-mobile">Bodyweight:</span>
          <span>
            <b>{getBodywweightAndUnit(stat.bodyWeight, units)}</b>
          </span>
        </div>
      )}
      {!hideExtras && !stat.bodyWeight && (
        <div className="bodyweight only-show-mobile">
          <span className="only-show-mobile">Bodyweight:</span>
          <span>
            <b>{` -`}</b>
          </span>
        </div>
      )}
    </div>
  );
};

export default StatInformation;
